/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CcmAccountStatusEnum } from './ccmAccountStatusEnum';
import { CcmAccountOnboardedByEnum } from './ccmAccountOnboardedByEnum';


/**
 * Summary information for a cloud cost management account
 */
export interface CloudCostMgmtAccountSummary { 
    /**
     * AWS Account ID
     */
    account_id: string;
    /**
     * Organization ID (UUID)
     */
    org_id?: string;
    /**
     * Organization name
     */
    org_name?: string;
    status: CcmAccountStatusEnum;
    onboarded_by: CcmAccountOnboardedByEnum;
    /**
     * Total monthly cost in USD
     */
    cost: number;
    /**
     * Potential monthly savings in USD
     */
    savings: number;
    /**
     * Total savings realized from cleaned resources in USD
     */
    realized_savings: number;
    /**
     * Number of cleanup candidates
     */
    candidates: number;
    /**
     * Number of already cleaned candidates
     */
    cleaned_candidates: number;
    /**
     * Last scan timestamp
     */
    last_scan?: Date;
}
export namespace CloudCostMgmtAccountSummary {
}


